import axios from 'axios'
import { API_URL } from '../constants'
/*
 * Default object structure for local storage
 *
 */

const checkDuplicateCats = (icons, icon) => icons.filter(i => i.cat === icon.cat).length

/**
 *
 * Add category to the store
 */

export const addCategory = categoryName => (dispatch, getState) => {
	const store = getState()
	const newStore = [categoryName, ...store.catstore.catstore]
	dispatch({
		type: 'FETCH_CAT_FULFILLED',
		payload: newStore
	})
	localStorage.setItem('categories', JSON.stringify(newStore))
}

/**
 *
 * Add category to the store
 */

export const emptyCategory = () => (dispatch) => {
	const newStore = []
	dispatch({
		type: 'FETCH_CAT_FULFILLED',
		payload: newStore
	})
	localStorage.setItem('categories', JSON.stringify(newStore))
}

/**
 *
 * @param {*} categoryName
 * Clean category store and add first one
 * Specially from home page
 */

export const clearnAndAddCategory = categoryName => (dispatch, getState) => {
	const newStore = [categoryName]
	dispatch({
		type: 'FETCH_CAT_FULFILLED',
		payload: newStore
	})
	localStorage.setItem('categories', JSON.stringify(newStore))
}

/**
 *
 * @param {*} categoryName
 * Remove category from store and update store
 */

export const removeCategory = categoryName => (dispatch, getState) => {
	const store = getState()
	const newStore = [...store.catstore.catstore]
	newStore.splice(newStore.indexOf(categoryName), 1)
	dispatch({
		type: 'FETCH_CAT_FULFILLED',
		payload: newStore
	})
	localStorage.setItem('categories', JSON.stringify(newStore))
}
/**
 * Fetch category in initial load page
 * Check local storage
 */

export const fetchCategory = () => dispatch => {
	let cats = JSON.parse(localStorage.getItem('categories'))
	cats = cats === null ? [] : cats
	dispatch({
		type: 'FETCH_CAT_FULFILLED',
		payload: cats
	})
}

/**
 * Fetch all selected icons from local storage and dispatch it for view
 * Parse string to object and dispatch fullfillment
 */
export const fetchSelectedIcons = () => dispatch => {
	const defaultIcons = {
		author: 'joomshaper',
		icon_count: 0,
		css_prefix_text: 'icon-',
		glyphs: {
			icofonts: [],
			custom: []
		},
		selected_glyphs: [],
		selected_cats: []
	}
	const icons = localStorage.getItem('icons')
	dispatch({
		type: 'FETCH_ICONS_FULFILLED',
		payload: icons ? JSON.parse(icons) : defaultIcons
	})
}

/*
 * Add icon to the local storage with stringify
 *
 * @icon_count -> increase by add
 * @glyphs -> Add each selected icon to this array
 * @selectedIcons -> Add selected icon id
 *
 */
export const addIcon = (icon, provider) => (dispatch, getState) => {
	let store = getState()
	let {
		iconstore: { iconstore },
		localstore: { icons }
	} = store

	iconstore.icon_count = iconstore.icon_count + 1

	if (provider === 'icofont') {
		iconstore.glyphs.icofonts.push(icon)
	}
	if (provider === 'custom') iconstore.glyphs.custom.push(icon)
	iconstore.selected_glyphs.push(icon.id)
	if (iconstore.selected_cats.indexOf(icon.cat) === -1) iconstore.selected_cats.push(icon.cat)

	if (icon.isDuotone) {
		const iconSecondary = icons.find(singleicon => singleicon.isDuotone && singleicon.name === icon.name && singleicon.assign === 'after');
		iconstore.glyphs.icofonts.push(iconSecondary)
		// iconstore.selected_glyphs.push(iconSecondary.id)
	}

	dispatch({ type: 'NEW_ICONS_FULFILLED', payload: iconstore })
	localStorage.setItem('icons', JSON.stringify(iconstore))
}

/*
 * Remove icon from the local storage. Parse local storage icon from string to obj
 *
 * @glyphs -> Remove deselect icon from array
 * @selected_glyphs -> Remove icon id from this array
 * @icon_count -> Decrease icon when one remove
 *
 */
export const removeIcon = (icon, provider) => (dispatch, getState) => {
	let store = getState()
	let newStore = { ...store.iconstore.iconstore }
	if (provider === 'icofont') {
		newStore.glyphs.icofonts = newStore.glyphs.icofonts.filter(item => {
			return icon.isDuotone ? item.name !== icon.name : item.id !== icon.id
		})
	}
	if (provider === 'custom') {
		newStore.glyphs.custom = newStore.glyphs.custom.filter(item => {
			return item.id !== icon.id
		})
	}
	newStore.selected_glyphs.splice(newStore.selected_glyphs.indexOf(icon.id), 1)
	newStore.icon_count = newStore.icon_count - 1 < 0 ? 0 : newStore.icon_count - 1

	if (checkDuplicateCats(newStore.glyphs.icofonts, icon) === 0)
		newStore.selected_cats.splice(newStore.selected_cats.indexOf(icon.cat), 1)

	localStorage.setItem('icons', JSON.stringify(newStore))
	dispatch({ type: 'ICON_DELETE_FULFILLED', payload: newStore })
}

export const fetchIcons = () => dispatch => {
	return axios.get(API_URL + '/api/icons/all')
		.then(function (response) {
			let { result, filter_category } = response.data
			dispatch({
				type: 'FETCHED_FILTER_ICON_AND_CATEGORY',
				category: filter_category,
				payload: result
			})
		})
		.catch(error => {
			console.error('ico error: ', error) // eslint-disable-line no-console
		})
}

/*
 * Replace the whole selection at once (the composer's add-all, clear and shared links).
 * Only what the font build needs is kept, so a large selection still fits in storage.
 */
const slim = icon => ({ id: icon.id, name: icon.name, cat: icon.cat, code: icon.code, assign: icon.assign, isDuotone: icon.isDuotone })

export const setCollection = icons => (dispatch, getState) => {
	const all = getState().localstore.icons
	const glyphs = []
	icons.forEach(icon => {
		glyphs.push(slim(icon))
		if (icon.isDuotone) {
			const after = all.find(item => item.isDuotone && item.name === icon.name && item.assign === 'after')
			if (after) glyphs.push(slim(after))
		}
	})
	const newStore = {
		author: 'joomshaper',
		icon_count: icons.length,
		css_prefix_text: 'icon-',
		glyphs: { icofonts: glyphs, custom: [] },
		selected_glyphs: icons.map(icon => icon.id),
		selected_cats: icons.map(icon => icon.cat).filter((cat, index, cats) => cats.indexOf(cat) === index)
	}
	dispatch({ type: 'NEW_ICONS_FULFILLED', payload: newStore })
	try {
		localStorage.setItem('icons', JSON.stringify(newStore))
	} catch (e) {
		// Storage full or unavailable: the selection still works for this visit
	}
}
